import { Expose, Transform, Type, plainToClass, plainToClassFromExist, plainToInstance } from 'class-transformer';
import { BaseReport } from './base-report-model';
import { BaseTeacher } from './base-teacher-model';
import { LanguageEnum } from '../../common';
import { TeacherPreferences } from './teacher-preference-model';
import { LevelOfExperience } from 'src/app/shared/common';

export class TeachersReport extends BaseReport {
  @Expose()
  @Transform(({ obj }) => plainToClass(BaseTeacher, obj, { strategy: 'excludeAll' }))
  @Type(() => BaseTeacher)
  teacher: BaseTeacher;

  @Expose({ name: 'teacherPreferance' })
  @Type(() => TeacherPreferences)
  teacherPreference: TeacherPreferences;

  @Expose() availableTimePerWeek: string;
  @Expose() evaluatorsRate: number;
  @Expose() failedCall: number;
  @Expose() incomingCall: number;
  @Expose() isFav: boolean;
  @Expose() isLoginBlocked: boolean;
  @Expose() isReserveBlocked: boolean;
  @Expose() isSubscribed: boolean;

  @Expose()
  @Transform(({ value }) => (value ? value.split(',&,') : []))
  languages: LanguageEnum[];
  @Expose() missedCall: number;
  @Expose() nearstSlotTime: string;
  @Expose() numberOfRefusedCalls: number;
  @Expose() sinchId: string;
  @Expose() status: string;
  @Expose() studentsRate: number;
  @Expose() sessionPrice: number;
  @Expose() sessionLongPrice: number;
  @Expose() systemRate: number;
  @Expose() totalMoney: number;
  @Expose() totalRate: number;
  @Expose() totalStudents: string;
  @Expose() technicalExperience: LevelOfExperience;
}
